import { useEffect } from "react";
import {
  Col,
  Row,
  CustomContainer,
  Cookie,
  useRouter,
  connect,
  useDispatch,
} from "../../atoms/DependencyHelper";
import Image from "../../atoms/image/image";
import { H5 } from "../../atoms/text/Text";
import colors from "../../../config/colors";
import PropTypes from "prop-types";
import { CheckoutStepper } from "../checkoutStepper/CheckoutStepper";
import labels from "../../../config/labels";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import {
  showSpinner,
  getCookieValue,
  hideSpinner,
} from "../../../utils/helperServices";
import {
  setNormalCheckoutCurrentStep,
  setPostCheckoutCurrentStep,
  removeCreditCheckStates,
  setPaymentMethodUrl,
  setPostOrderResponse,
} from "../../../Redux/actions/checkoutAction";
import { deleteItemsFromCart } from "../../../Redux/actions/cartAction";
import * as Analytics from "../../../services/analyticsUtag";
import config from "../../../config/index";
import styles from "./CheckoutNav.module.scss";
import { SET_CREDIT_VETTING_RESULT } from "../../../Redux/actionTypes/index";

const CheckoutNav = ({
  steps = [],
  stepsShow,
  stepsWidth,
  activeStep,
  activeStepNo,
  userLoggedIn,
  customerStatus,
  setNormalCheckoutCurrentStep,
  setPostCheckoutCurrentStep,
  removeCreditCheckStates,
  creditVettingResultData,
  deleteItemsFromCart,
  cartProducts,
  multicartFlag,
  setPaymentMethodUrl,
  setPostOrderResponse,
}) => {
  const router = useRouter();
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const urlPrefix = config.envConfigs[env].shoppingUrlPrefix;

  const dispatch = useDispatch();

  const dealCartProduct = cartProducts.find(
    (cartProduct) =>
      cartProduct?.product?.is_deal_product === 1 &&
      cartProduct?.product?.__typename === labels.lbl_product_type_bundle
  );
  const cartId = getCookieValue("cart_id");
  const cartProductId = dealCartProduct?.id;

  const clearReduxState = async () => {
    setNormalCheckoutCurrentStep(null);
    setPostCheckoutCurrentStep(null);
    removeCreditCheckStates(null);
    setPaymentMethodUrl(null);
    setPostOrderResponse({});

    Cookie.remove(config.order_id);
    Cookie.remove(config.pay_fail_count);
    Cookie.remove("guest_checkout");
  };

  const handleExtCheckout = async () => {
    showSpinner();

    if (creditVettingResultData) {
      let resultCode = creditVettingResultData?.resultCode;
      let applicationStatus =
        creditVettingResultData.vettingOutcome?.vettingSummary
          ?.applicationStatus;
      let vettingStatus =
        creditVettingResultData.vettingOutcome?.vettingSummary?.vettingStatus;
      if (
        applicationStatus === labels.creditVetting.lbl_processed &&
        vettingStatus ===
          labels.creditVetting.lbl_approved_with_condition_status &&
        resultCode ===
          labels.creditVetting.lbl_resultcode_approved_with_condition &&
        dealCartProduct
      ) {
        await deleteItemsFromCart(cartId, cartProductId);
      }
      dispatch({
        type: SET_CREDIT_VETTING_RESULT,
        payload: null,
      });
    }

    let pageName = Analytics.getUtagData(["page_name"]).page_name;

    if (activeStep == "xds") {
      Analytics.link({
        link_type: "o",
        link_name: `checkout: authentication: ${customerStatus}: exit checkout`,
        page_name: `${pageName}`,
      });
    } else if (activeStep == "otp") {
      Analytics.link({
        link_type: "o",
        link_name: `checkout: otp authentication: ${customerStatus}: exit checkout`,
      });
    } else if (activeStep == "authentication") {
      Analytics.link({
        link_type: "o",
        link_name: `checkout: lets get started: ${customerStatus}: exit checkout`,
        page_name: `${pageName}`,
      });
    } else if (activeStep == "creditCheck") {
      Analytics.link({
        link_type: "o",
        link_name: `checkout: credit check: ${customerStatus}: exit checkout`,
        page_name: `${pageName}`,
      });
    } else if (activeStep == "delivery") {
      Analytics.link({
        link_type: "o",
        link_name: `checkout: delivery: ${customerStatus}: exit checkout`,
        page_name: `${pageName}`,
      });
    } else if (activeStep == "review") {
      Analytics.link({
        link_type: "o",
        link_name: `checkout: review order: ${customerStatus}: exit checkout`,
        page_name: `${pageName}`,
      });
    } else if (activeStep == "payment") {
      Analytics.link({
        link_type: "o",
        link_name: `checkout: payment: ${customerStatus}: exit checkout`,
        page_name: `${pageName}`,
      });
    } else if (
      activeStep == "paymentError" ||
      activeStep == "paymentRedirect"
    ) {
      Analytics.link({
        link_type: "o",
        link_name: `checkout: make payment: ${customerStatus}: exit checkout`,
        page_name: `${pageName}`,
      });
    } else {
      Analytics.link({
        link_type: "o",
        link_name: `${pageName}: exit checkout`,
        page_name: `${pageName}`,
      });
    }
    if (activeStep == "orderConfirmation") {
      const orderCreated = getCookieValue(config.order_id);
      if (orderCreated) {
        if (userLoggedIn) {
          await router.push(`${urlPrefix}/view-order-history`);
        } else {
          await router.push(`${urlPrefix}/products`);
        }
      } else {
        if (multicartFlag) {
          await router.push(`/`);
        } else {
          await router.push(`${urlPrefix}/cart`);
        }
        hideSpinner();
      }
    } else {
      if (multicartFlag) {
        await router.push(`/`);
      } else {
        await router.push(`${urlPrefix}/cart`);
      }
      hideSpinner();
    }
    await clearReduxState();
  };

  return (
    <div className={styles["checkout-nav"]}>
      <CustomContainer className={styles["container"]}>
        <Row noGutters>
          <Col
            className={`d-flex align-items-center ${styles["logo"]} ${styles["col-side"]}`}
          >
            <CustomContainer className="d-block d-lg-none">
              <Image
                img_path={`${imagePrefix}/assets/images/global-header.svg`}
                img_width="2rem"
                img_height="2rem"
                id="checkout-header-mob-logo"
              />
            </CustomContainer>
            <CustomContainer className="d-none d-lg-block">
              <Image
                img_path={`${imagePrefix}/assets/images/global-header.svg`}
                img_width="2.5rem"
                img_height="2.5rem"
                id="checkout-header-logo"
              />
            </CustomContainer>
            <H5
              className={styles["title-font"]}
              color={colors.White0}
              textAlign="left"
              fontWeight="bold"
              padding="0 0 0 1rem"
              id="checkout-header-title"
            >
              {labels.lbl_checkout_header.title}
            </H5>
          </Col>
          <Col className={`justify-content-center ${styles["col-mid"]}`}>
            {stepsShow && (
              <CheckoutStepper
                steps={steps}
                activeStepNo={activeStepNo}
                stepsWidth={stepsWidth}
              />
            )}
          </Col>
          <Col
            className={`d-flex align-items-center justify-content-end ${styles["col-side"]}`}
          >
            <CTAButton
              className={styles["exit-btn"]}
              variant="outline white"
              handleClick={handleExtCheckout}
              id="checkout-header-exit-button"
            >
              <span
                className={`d-none d-lg-inline d-md-inline d-sm-inline ${styles["title-font"]}`}
              >
                {labels.lbl_exit_checkout.desktop}
              </span>
              <span className="d-lg-none d-md-none d-sm-none">
                {labels.lbl_exit_checkout.mobile}
              </span>
            </CTAButton>
          </Col>
        </Row>
      </CustomContainer>
    </div>
  );
};

CheckoutNav.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      stepNo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
    })
  ),
  activeStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  activeStepNo: PropTypes.number,
};

const mapStateToProps = (state) => ({
  userLoggedIn: state.navDetails.isUserLoggedIn,
  creditVettingResultData: state.checkoutDetails.creditVettingResult,
  cartProducts: state.cartDetails.cartProductItems,
});

const mapDispatchToProps = {
  setNormalCheckoutCurrentStep,
  setPostCheckoutCurrentStep,
  removeCreditCheckStates,
  deleteItemsFromCart,
  setPaymentMethodUrl,
  setPostOrderResponse,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutNav);
